import { IDialogTexts } from "@saleor/components/PromptDialog/types";

export const INITIAL_ROW_NUMBER = 10;

export const PROMPT_DIALOG_TEXTS: IDialogTexts = {
  title: "You will be redirected to set unlock code page.",
  subTitle:
    "Any unsaved changes on this page will be discarded. Be sure to save them before proceeding.",
  proceedButtonText: "Proceed without Saving",
  cancelButtonText: "Set Later"
};
